<!--
  Shared loading placeholder. `aria-busy` + `aria-live` sit here rather than on each consumer:
  the spinner glyph is `aria-hidden`, so without them a screen reader is told nothing at all
  while a module loads. Every consumer gains the announcement by using this component.
-->
<template>
  <div
    class="flex flex-col flex-1 items-center justify-center py-12"
    aria-busy="true"
    aria-live="polite"
  >
    <i class="ri-loader-4-line animate-spin text-3xl text-(--text-text-disabled-strong)" aria-hidden="true" />
  </div>
</template>
